import { deepMap } from "nanostores"

export interface ElementHeightStore {
  [key: string]: number | undefined
}

const $elementHeightStore = deepMap<ElementHeightStore>({})

export function setElementHeight(key: string, height: number) {
  $elementHeightStore.setKey(key, height)
}

export function removeElementHeight(key: string) {
  $elementHeightStore.setKey(key, undefined)
}

export { $elementHeightStore }
